import { createApp } from 'vue'
import App from './App.vue'
import '@digithia/input/text'
import '@digithia/input/select'
import '@digithia/input/checkbox'
import '@digithia/ui'

createApp(App).mount('#app')
